import { useNavigate } from "react-router-dom";
import { useAuthUser } from "../auth/AuthService";
import { useEffect } from "react";

export default function Home() {
    const authUser = useAuthUser();
    const navigate = useNavigate();
    
    useEffect(() => {
        if (authUser()?.role === 'user' || authUser()?.role === 'secc' || authUser()?.role === 'investor') {
            navigate('/market-summary', {state: {login: true}});
        } else if (authUser()?.role === 'member_firm') {
            navigate('/screen1');
        }else if ( authUser()?.role === 'issuer') {
            navigate('/screen1_issuer');
        } else if (authUser()?.role === 'admin' || authUser()?.role === 'manager') {
            navigate('/admin/user');
        } else if (!authUser()?.role) {
            navigate('/login');
        }
    }, [])
}